import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { useIntercom } from 'react-use-intercom';
import { api } from '../api';
import { intercomEvents } from '../intercom-events';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import queryClient from '../query-client';

export type ExcludeWorksheetsRequest = { id: string }[];

async function excludeWorksheets(workpaperId: string, request: ExcludeWorksheetsRequest): Promise<void> {
    await api.post(`/workpapers/${workpaperId}/worksheets/exclude`, request);
}

export function useExcludeWorksheets(): UseMutationResult<void, AxiosError, ExcludeWorksheetsRequest, unknown> {
    const { id: workpaperId } = useWorkpaperContext();
    const { trackEvent } = useIntercom();
    return useMutation((req) => excludeWorksheets(workpaperId, req), {
        onSettled: (_, __, req) => {
            trackEvent(intercomEvents.worksheet.excluded.event, intercomEvents.worksheet.excluded.metaData(req.length));
            queryClient.invalidateQueries(['worksheets']);
            queryClient.invalidateQueries([workpaperId, 'trial-balance']);
            queryClient.invalidateQueries(['other-schedules']);
            queryClient.invalidateQueries(['history']);
        },
    });
}
